"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('sperm', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2379 24.4743C20.0937 25.7738 20.5678 27.1486 21.8463 28.0438C23.2461 29.0239 24.7936 29.5443 26.0154 29.0591C28.3224 28.143 29.9913 25.1506 32.0269 22.2435C35.9866 16.5884 35.9801 7.85863 32.2871 5.27276C28.5941 2.68689 20.4439 5.70532 16.4842 11.3604C14.5493 14.1237 12.0151 17.8054 12.1677 19.3629C12.2962 20.6742 12.7371 21.4048 14.1254 22.6376C15.5137 23.8704 16.2574 23.0876 18.2379 24.4743Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }), _react.default.createElement("path", {
    d: "M13.6177 22.3167C10.0771 26.2143 9.60947 29.1759 12.2149 31.2017C14.8203 33.2274 18.0919 32.2291 22.0297 28.2068",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M12.2388 31.2271C9.14193 34.6143 8.57234 37.7732 10.53 40.7037C13.4665 45.0994 19.2839 44.8592 22.1241 41.5826C24.9643 38.306 30.3083 30.1865 36.1831 31.8557C42.0579 33.5248 41.0606 39.9436 37.1222 40.618",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  })));
});

exports.default = _default;